export default __webpack_public_path__ + "static/media/guru.alt.1e2955a1.png";